import { Notification } from '../types';

export const NOTIFICATION_EVENT = 'NOTIFICATION_EVENT';

export interface NewNotificationEvent {
    type: typeof NOTIFICATION_EVENT;
    payload: Notification;
}

// Action Creators

export const newNotification: (payload: Notification) => NewNotificationEvent = (payload) => {
    return {
        type: NOTIFICATION_EVENT,
        payload: payload,
    };
};
